import { HttpClient } from '@/shared/lib/http-client';

export const fetchTopBanner = async () => {
  const response = await HttpClient.post('/banners/getTop');

  return response.data?.data;
};
